<template>
  <div class="break section-block row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.TRUSTEE_ORGANIZATION,
        })
      "
    ></WrapperField>

    <TitleField fieldName="isAssignee" :fieldGroup="FieldGroup.ORGANIZATION" />
    <AssigneeSection :data="data.assignee" />
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import AssigneeSection from '@/components/elements/statement/FullStatementView/elements/Assignee';

export default {
  name: 'TrusteeOrganization',
  components: {
    WrapperField,
    TitleField,
    AssigneeSection,
  },
  props: ['data'],
  data: () => ({
    createDataField,
    FieldGroup,
  }),
};
</script>
